// extracted by mini-css-extract-plugin
export default {"propertyBlock":"fractionalBlocksCard_propertyBlock__OgHtG"};